
<mat-dialog-content>
  <mat-icon class="mat-icon-large">cloud_download</mat-icon>

  <div class="progress-container">
    <p class="download-message">O download foi iniciado. <br> Por favor, aguarde até que o download seja concluído.</p>

    <mat-progress-bar
      class="progress-bar"
      mode="determinate"
      [value]="data.progress"
    ></mat-progress-bar>

    <!-- Porcentagem de Progresso Abaixo da Barra -->
    <p class="progress-text">{{ data.progress }}% concluído</p>

    <!-- Botões de Cancelar e Fechar Centralizados -->
    <div class="button-container">
      <button class="cancel-button" (click)="cancelDownload()">Cancelar Download</button>
      <button class="close-button" (click)="closeDialog()">Fechar</button>
    </div>
  </div>
</mat-dialog-content>
